import type { ToastContent, ToastOptions } from 'react-toastify'
import { toast } from 'react-toastify'

export async function toastAwaitAllSettling<T extends readonly unknown[] | []>(
  content: ToastContent<unknown>,
  promises: T,
  options?: ToastOptions<{}>,
) {
  const id = toast.info(content, { ...options, progress: 0 })
  let settled = 0

  for (const p of promises)
    if (p instanceof Promise)
      p.finally(() => {
        settled++
        toast.update(id, { progress: settled / promises.length })
      })

  const ret = await Promise.allSettled(promises)

  toast.dismiss(id)

  return ret
}

export async function toastAwaitAll<T extends readonly unknown[] | []>(
  content: ToastContent<unknown>,
  promises: T,
  options?: ToastOptions<{}>,
) {
  const id = toast.info(content, { ...options, progress: 0 })
  let settled = 0

  for (const p of promises)
    if (p instanceof Promise)
      p.finally(() => {
        settled++
        toast.update(id, { progress: settled / promises.length })
      })

  try {
    return await Promise.all(promises)
  } finally {
    toast.dismiss(id)
  }
}
